import Link from "next/link";
import { memo } from "react";
import cn from "classnames";

const KnowMore = memo(({ className, children, path= "/" }) => {
  return (
    <Link
      className={cn(
        "text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit",
        className
      )}
      href={path}
      aria-label={children ? `Navigate to ${children}` : "Know More"}
    >
      {children}
    </Link>
  );
});

KnowMore.displayName = "KnowMore";

export default KnowMore;
